// Click to play/pause the portfolio videos. Only one plays at a time.
document.addEventListener('click', function (event) {
  var button = event.target.closest('.phone .play');
  if (!button) return;
  var phone = button.closest('.phone');
  var video = phone.querySelector('video');
  if (!video) return;

  if (video.paused) {
    document.querySelectorAll('.phone video').forEach(function (other) {
      if (other !== video && !other.paused) other.pause();
    });
    video.play();
  } else {
    video.pause();
  }
});

document.addEventListener('play', function (event) {
  if (event.target.tagName !== 'VIDEO') return;
  var phone = event.target.closest('.phone');
  if (phone) phone.classList.add('is-playing');
  event.target.setAttribute('controls', '');
}, true);

document.addEventListener('pause', function (event) {
  if (event.target.tagName !== 'VIDEO') return;
  var phone = event.target.closest('.phone');
  if (phone) phone.classList.remove('is-playing');
}, true);

// Contact email is stored reversed + base64 so scrapers can't read it from the HTML.
document.querySelectorAll('.js-mail[data-m]').forEach(function (link) {
  try {
    var address = atob(link.getAttribute('data-m')).split('').reverse().join('');
    link.href = 'mailto:' + address;
    link.textContent = address;
  } catch (e) {}
});
